<script lang="ts">
  /**
   * <Modal
   *  {open}
   *  onclose={() => run()}
   *  closeButton={true}
   *  closeOnEsc={true}
   *  closeOnOuterClick={true}
   *  large={false}
   *  style="max-width: 350px !important;"
   * />
   */
  import { fly } from "svelte/transition"
  import { X } from "lucide-svelte"

  let {
    open = $bindable(false),
    closeButton = true,
    closeOnEsc = true,
    closeOnOuterClick = false,
    large = false,
    closeConfirm = false,
    hasBackdrop = true,
    theme = "light",
    children,
    onclose = () => {},
    ...extra
  } = $props()

  const handleKeyup = ({ key }) => {
    if (closeOnEsc && key === "Escape") {
      closeModal()
    }
  }

  function closeModal() {
    if (!closeConfirm) {
      open = false
    }
    onclose()
  }

  function handleOuterClick(event: Event) {
    if (closeOnOuterClick && event.target === dialog) {
      closeModal()
    }
  }

  const disableScroll = () => {
    document.body.style.overflow = "hidden" // ADD THIS LINE
    document.body.style.height = "100%"
  }
  const enableScroll = () => {
    document.body.style.overflow = "auto" // ADD THIS LINE
    document.body.style.height = "auto"
  }

  let dialog = $state<HTMLDialogElement | null>(null)

  $effect(() => {
    if (open) {
      disableScroll()
      dialog?.showModal()
    } else {
      enableScroll()
      dialog?.close()
    }
  })
</script>

<svelte:window
  onkeyup={(e: KeyboardEvent) => {
    e.preventDefault()
    handleKeyup(e)
  }}
/>
{#if open}
  <dialog
    class={[
      large
        ? "lg:max-w-4xl w-4xl md:max-w-3xl max-w-2xl"
        : "lg:max-w-3xl md:max-w-xl sm:max-w-lg",
      "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-[90vw] rounded-xl fixed shadow-lg",
      extra.class
    ]}
    bind:this={dialog}
    onclick={handleOuterClick}
    transition:fly={{ y: 300 }}
    style={hasBackdrop
      ? "--backdrop-color: rgba(0, 0, 0, 0.5)"
      : "--backdrop-color: transparent"}
  >
    <div class="p-8">
      {#if closeButton}
        <div class="block absolute top-0 right-0 pt-4 pr-4">
          <button
            type="button"
            onclick={() => closeModal()}
            data-name="close-modal"
            class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            class:bg-white={theme === "light"}
          >
            <span class="sr-only">Close</span>
            <X class="w-6 h-6" />
          </button>
        </div>
      {/if}

      {@render children()}
    </div>
  </dialog>
{/if}

<style>
  dialog {
    max-height: 95vh;
  }

  dialog::backdrop {
    background-color: var(--backdrop-color);
  }
</style>
